import React, { FC } from 'react';
import './PageLoader.css';
import { DEFAULT_PAGE_LOADING_MESSAGE } from '@/Shared/Constants/ui.constants';
import { FaSpinner } from '@/Shared/Lib/UI/Icons';

interface PageLoaderProps {
	message?: string
}

const PageLoader: FC<PageLoaderProps> = ({ message = DEFAULT_PAGE_LOADING_MESSAGE }) => (
	<div className="PageLoader" data-testid="PageLoader">
		<div className='PageLoader__box'>
			<div className='flex-row PageLoader-items'>
				<div className='spinner'><FaSpinner/></div>
				<div className='spinner'><FaSpinner/></div>
				<div className='spinner'><FaSpinner/></div>
				
			</div>
			<div className='PageLoader-message'> {message} </div>
		</div>
	</div>
);

export default PageLoader;
